import React from 'react';
import { TypedMemo } from '../../common/types';
import { useShareTokenContext } from '../../music24/contexts/ShareTokenContext';
import { PrivateOnlyRouteController } from './PrivateOnlyRouteController';

const PrivateOrSharedTokenRouteControllerComponent: React.FC<React.PropsWithChildren> = ({ children }) => {
  const { isPublicMode } = useShareTokenContext();
  if (isPublicMode) {
    return <>{children}</>;
  }
  return <PrivateOnlyRouteController>{children}</PrivateOnlyRouteController>;
};

export const PrivateOrSharedTokenRouteController = TypedMemo(PrivateOrSharedTokenRouteControllerComponent);
